import { withChartLayout } from 'components/common';
import BloodGlucose from 'components/features/chart/vital-signs/blood-glucose/BloodGlucose';

const BloodGlucosePage = withChartLayout('Blood Glucose')(BloodGlucose);
export default BloodGlucosePage;
